<template>
  <div class="school-container">
    <div id="school-search--map" class="school-search--map w-full h-full"></div>
    <div v-if="shopSelected" class="shop-info-container mb-3">
      <div class="shop-info-container__content">
        <div class="sm:mr-2 image-section">
          <img loading="lazy" :src="'/storage/' + shopSelected.image" alt="shop-image" />
        </div>
        <div class="flex flex-col sm:ml-2 w-full">
          <h4>{{ shopSelected.name }}</h4>
          <p>{{ shopSelected.address }}</p>
          <p>{{ shopSelected.description }}</p>
          <a :href="'mailto:' + shopSelected.email" class="flex items-center">
            <img
              src="/img/icons/email-copy.svg"
              alt="email-copy"
              class="mr-2"
            />
            {{ shopSelected.email }}
          </a>
          <div class="flex sm:flex-row flex-col mt-2">
            <a
              :href="shopSelected.url"
              class="
                btn btn-outline-primary
                sm:mr-2
                flex
                justify-center
                items-center
              "
            >
              <img loading="lazy" src="/img/icons/icon-web.svg" alt="icon-web" class="mr-2" />
              Website
            </a>
            <a
              :href="'tel:+34' + shopSelected.phone"
              class="
                btn btn-primary
                mt-4
                sm:mt-0 sm:ml-2
                flex
                justify-center
                items-center
              "
            >
              <img
                src="/img/icons/phone-call-white.svg"
                alt="phone-call"
                class="mr-2"
              />
              {{ shopSelected.phone }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["shops"],
  data() {
    return {
      markers: [],
      shopSelected: this.shops[0],
      test: "",
    };
  },
  mounted() {
    this.initMap();
  },
  methods: {
    initMap() {
      this.map = new google.maps.Map(
        document.getElementById("school-search--map"),
        {
          zoom: 8,
        }
      );
      this.setupMap(null);
    },
    setupMap(zoom) {
      return new Promise((resolve) => {
        this.addMapMarkers();

        this.setMapCenter(
          this.shops[0] || {
            latitude: 41.388518,
            longitude: 2.166979,
          }
        );
        if (zoom != null) this.map.setZoom(zoom);
        resolve();
      });
    },
    setMapCenter(center) {
      this.map.setCenter({
        lat: Number(center.latitude),
        lng: Number(center.longitude),
      });
    },
    addMapMarkers() {
      const that = this;
      let marker, location;
      this.shops.forEach((shop, key) => {
        location = {
          lat: Number(shop.latitude),
          lng: Number(shop.longitude),
        };
        marker = new google.maps.Marker({
          position: location,
          map: this.map,
        });
        google.maps.event.addListener(marker, "mouseover", function (e) {
          that.setShop(shop);
        });
        google.maps.event.addListener(marker, "click", function (e) {
          that.setShop(shop);
        });
        shop.marker = marker;
        this.markers.push(marker);
      });
    },
    setShop(shop) {
      this.shopSelected = {};
      this.shopSelected = { ...shop };
    },
  },
};
</script>

<style lang="scss">
.school-container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;

  .shop-info-container {
    max-width: 535px;
    width: 100%;
    display: flex;
    background-color: white;
    position: absolute;
    bottom: 0;
    -webkit-box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.3);

    &__content {
      display: flex;
      justify-content: space-between;
      width: 100%;
      @media (max-width: 640px) {
        flex-direction: column;
        align-items: center;
      }
      padding: 1rem;

      .image-section {
        min-width: 150px;
        height: 150px;

        img {
          width: 150px;
        }
      }

      .btn {
        padding: 11px;
      }
    }
  }
}
.school-search--map {
  height: calc(100vh);
  @media (max-width: 768px) {
    height: calc(115vh);
  }
}
</style>